import { defaultApiState } from '../api.state';

export const collectionMutations = {
  GET_COLLECTIONS_LOADING(state) {
    state.apiState.getCollections = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_COLLECTIONS_SUCCESS(state, payload) {
    state.apiState.getCollections = {
      ...defaultApiState,
      success: true,
    };
    state.collections = payload;
  },
  GET_COLLECTIONS_ERROR(state, error) {
    state.apiState.getCollections = {
      ...defaultApiState,
      error,
    };
  },
  ADD_COLLECTION_LOADING(state) {
    state.apiState.addCollection = {
      ...defaultApiState,
      loading: true,
    };
  },
  ADD_COLLECTION_SUCCESS(state) {
    state.apiState.addCollection = {
      ...defaultApiState,
      success: true,
    };
  },
  ADD_COLLECTION_ERROR(state, error) {
    state.apiState.addCollection = {
      ...defaultApiState,
      error,
    };
  },
  UPDATE_COLLECTION_LOADING(state) {
    state.apiState.updateCollection = {
      ...defaultApiState,
      loading: true,
    };
  },
  UPDATE_COLLECTION_SUCCESS(state, payload) {
    state.apiState.updateCollection = {
      ...defaultApiState,
      success: true,
    };
    state.collection = payload;
  },
  UPDATE_COLLECTION_ERROR(state, error) {
    state.apiState.updateCollection = {
      ...defaultApiState,
      error,
    };
  },
  GET_COLLECTION_LOADING(state) {
    state.apiState.getCollection = {
      ...defaultApiState,
      loading: true,
    };
    state.collection = undefined;
  },
  GET_COLLECTION_SUCCESS(state, data) {
    state.apiState.getCollection = {
      ...defaultApiState,
      success: true,
    };
    state.collection = data;
  },
  GET_COLLECTION_ERROR(state, error) {
    state.apiState.getCollection = {
      ...defaultApiState,
      error,
    };
  },
  DELETE_COLLECTION_LOADING(state) {
    state.apiState.deleteCollection = {
      ...defaultApiState,
      loading: true,
    };
  },
  DELETE_COLLECTION_SUCCESS(state, payload) {
    state.apiState.deleteCollection = {
      ...defaultApiState,
      success: true,
    };
    state.collections = state.collections.filter(o => o.id !== payload.id);
  },
  DELETE_COLLECTION_ERROR(state, error) {
    state.apiState.deleteCollection = {
      ...defaultApiState,
      error,
    };
  },
  UPDATE_SEQUENCE_LOADING(state) {
    state.apiState.updateSequence = {
      ...defaultApiState,
      loading: true,
    };
  },
  UPDATE_SEQUENCE_SUCCESS(state) {
    state.apiState.updateSequence = {
      success: true,
    };
  },
  UPDATE_SEQUENCE_ERROR(state, error) {
    state.apiState.updateSequence = {
      ...defaultApiState,
      error,
    };
  },
};
